export const INSTRUCAO_TRABALHO = 'INSTRUCAO_TRABALHO';
export const VISUALIZAR_IT = 'VISUALIZAR_IT';
